// @ts-strict-ignore
import { useMemo } from 'react'
import { isCryptoCustomerWallet } from 'pages/Customers/helpers/utils'
import { useWalletActionContext } from 'pages/Wallets/context/WalletSheetProvider'
import { SourceWallet, SourceWalletTypes } from 'types/move/move'
import { WalletTransferType } from 'types/unifiedPayouts/unifiedPayouts'

export const useSourceWallet = (): SourceWallet => {
  const [walletAction] = useWalletActionContext()

  const sourceWallet: SourceWallet = useMemo(() => {
    const { sourceCustomerWallet, sourceWallet, sourceWalletType } = walletAction?.meta || {}

    if (sourceWalletType === WalletTransferType.MAIN && !!sourceWallet) {
      return {
        walletId: sourceWallet?.lsid,
        walletName: sourceWallet?.description,
        currency: sourceWallet?.currency?.code,
        balance: sourceWallet?.balance,
        walletType: SourceWalletTypes.MAIN,
        isFiat: sourceWallet?.currency?.fiat ?? false,
      }
    } else if (sourceWalletType === WalletTransferType.CUSTOMER && !!sourceCustomerWallet) {
      return {
        walletId: sourceCustomerWallet.id,
        walletName: sourceCustomerWallet?.name,
        currency: sourceCustomerWallet?.balance?.currencyCode,
        balance: sourceCustomerWallet?.balance?.value,
        walletType: SourceWalletTypes.CUSTOMER,
        isFiat: !isCryptoCustomerWallet(sourceCustomerWallet?.balance?.currencyCode),
      }
    }
  }, [walletAction])

  return sourceWallet
}
